import {TicketStatusCategory} from '@frontapp/ticketing';
import React, {FC} from 'react';

import {DropdownItemLeftIconBase} from '../../../../libs/shared/ui/src/components/dropdowns/items/dropdownItemLeftIconBase';
import {TicketStatusIndicator} from './ticketStatusIndicator';

/*
 * Props.
 */

interface TicketStatusDropdownItemIconProps {
  category: TicketStatusCategory;
}

/*
 * Component.
 */

export const TicketStatusDropdownItemIcon: FC<TicketStatusDropdownItemIconProps> = (props) => (
  <DropdownItemLeftIconBase>
    <TicketStatusIndicator category={props.category} />
  </DropdownItemLeftIconBase>
);
